import React, { useEffect, useState } from "react";

const NotificationIcon: React.FC<{ count: number }> = ({ count }) => {
  const [shake, setShake] = useState(false);

  // Effect to trigger shake on count change
  useEffect(() => {
    if (count > 0) {
      setShake(true);
      const timer = setTimeout(() => setShake(false), 3000); // Reset shake after 3 seconds
      return () => clearTimeout(timer);
    }
  }, [count]);

  return (
    <div className="relative inline-block cursor-pointer">
      <img
        className={`h-5 mt-2 ${shake ? "shake" : ""}`} // Apply the shake class when state is true
        src="/Images/DashboardImages/notificationBell.png"
        alt="NotificationIcon"
      />
      {count > 0 && (
        <span className="absolute top-[4px] right-[-5px] bg-[red] text-[white] rounded-[50%] px-[4px] py-[1.5px] text-[10px] leading-none font-[bold]">
          {count > 9 ? "9+" : count}
        </span>
      )}
    </div>
  );
};

export default NotificationIcon;
